import React from 'react'
import Thank from '../components/thankyou/Thank'

function ThankYou() {
  return (
    <div>
        <Thank />
    </div>
  )
}

export default ThankYou